import { render } from "./ContaModal.vue?vue&type=template&id=e777b4a8&scoped=true&ts=true"
import script from "./ContaModal.vue?vue&type=script&lang=ts"
export * from "./ContaModal.vue?vue&type=script&lang=ts"

import "./ContaModal.vue?vue&type=style&index=0&id=e777b4a8&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e777b4a8"]])

export default __exports__